import { useEffect, useState } from 'react'
import RenderKeyValue from '@/components/Content/RenderKeyValue'

import './index.less'

const prefix = 'slopeDirection'
const headerArrDefault = [{ key: '주소', value: '전주시 덕진구 송전동1가 10-10' }]
const contentArrDefault = [
  { key: '전체면적(㎡)', value: '1889.97' },
  { key: '평균경사도(°)', value: '22.16' },
]

function SlopeDirection(props: any) {
  const { polygonSource8 } = props
  const [headerArr, setHeaderArr] = useState(headerArrDefault)
  const [contentArr, setContentArr] = useState<any>(contentArrDefault)
  useEffect(() => {
    if (Array.isArray(polygonSource8) && polygonSource8.length > 0) {
      setHeaderArr([{ key: '주소', value: polygonSource8[8].position }])
      setContentArr([
        { key: '전체면적(㎡)', value: polygonSource8[8].area },
        { key: '평균경사도(°)', value: polygonSource8[8].avgDegrees },
      ])
    }
  }, [polygonSource8])
  return <div className={`${prefix}`}>
    <div className={`${prefix}-box1`}>
      <p>분석결과</p>
      <ul className={`${prefix}-box1-ul`}>
        <li className={`${prefix}-box1-ul-commonLi`}>
          <span className={`${prefix}-box1-ul-key`}>{headerArr[0].key}</span>
          <span className={`${prefix}-box1-ul-value`}>{headerArr[0].value}</span>
        </li>
        <div className={`${prefix}-box1-ul-box`}>
          <RenderKeyValue contentArr={contentArr} />
        </div>
      </ul>
    </div>
  </div>
}

export default SlopeDirection
